jQuery(function ($) {
  if ($(".accueil").length) {
    // Open
    $(".domaine").each(function () {
      $(this).on("click", function () {
        if ($(this).hasClass("open")) {
          $(this).removeClass("open");
        } else if (!$(this).hasClass("disabled")) {
          $(".domaine").removeClass("open");
          $(this).addClass("open");
        }
      });
    });
    // Select change
    $("select").on("change", function () {
      let diplome = this.value;
      $(".domaine").removeClass("open disabled");
      $(".domaine li").addClass("visible");
      $(".domaine li").removeClass("last");
      if (diplome != "") {
        $(".domaine").each(function () {
          let domaine = $(this);
          let count = 0;
          let last = null;
          $(this)
            .find("li")
            .each(function () {
              if ($(this).data("diplome") == diplome) {
                count++;
                last = $(this);
              } else {
                $(this).removeClass("visible");
              }
            });

          if (last != null) last.addClass("last");

          if (count == 0) {
            domaine.addClass("disabled");
          }
        });
      }
    });
  }
  // Video mobile
  if ($(window).width() <= 767) {
    $(".accueil-video").css("margin-top", $("header").height());
  }
});
